import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BillingStaging } from 'markets-lib';

import { config } from '../config';
import { prepHeaders } from '../util';

interface ExtraParameters {
  contractId: string;
}

export const billingsApi = createApi({
  reducerPath: 'billings',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders: prepHeaders,
    credentials: 'include',
  }),
  tagTypes: ['Billings'],
  endpoints: (builder) => ({
    upsert: builder.mutation<BillingStaging & ExtraParameters, BillingStaging>({
      query: (payload) => ({
        url: '/api/billings-staging',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Billings'],
    }),
    getAll: builder.query<BillingStaging[], void>({
      query: () => '/api/billings-staging',
      providesTags: ['Billings'],
    }),
    getById: builder.query<BillingStaging, BillingStaging['id']>({
      query: (id) => `/api/billings-staging/${id}`,
      providesTags: ['Billings'],
    }),
    remove: builder.mutation<BillingStaging[], BillingStaging['id']>({
      query: (id) => ({
        url: `/api/billings-staging/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Billings'],
    }),
  }),
});

export const {
  endpoints,
  middleware,
  reducer,
  reducerPath,
  useUpsertMutation,
  useRemoveMutation,
  useGetAllQuery,
  useGetByIdQuery,
} = billingsApi;
